import { supabase } from '@/lib/supabase';
import { Project } from '@/shared/types/api';

export interface InsightsFilters {
  projectIds: number[] | undefined;
  subprojectIds: number[] | undefined;
  dateFrom?: string | Date;
  dateTo?: string | Date;
}

export const getFilteredInsightsProjects = async ({
  orgId,
  filters,
}: {
  orgId: number;
  filters: InsightsFilters;
}): Promise<(Project & { contractors?: unknown[] })[]> => {
  const { data, error } = await supabase.rpc('get_filtered_insights_projects', {
    p_org_id: orgId,
    p_project_ids: filters?.projectIds,
    p_subproject_ids: filters?.subprojectIds,
    p_date_from: filters?.dateFrom
      ? typeof filters.dateFrom === 'string'
        ? filters.dateFrom
        : filters.dateFrom.toISOString().split('T')[0]
      : undefined,
    p_date_to: filters?.dateTo
      ? typeof filters.dateTo === 'string'
        ? filters.dateTo
        : filters.dateTo.toISOString().split('T')[0]
      : undefined,
  });

  if (error) {
    throw error;
  }

  return (data ?? []) as (Project & { contractors?: unknown[] })[];
};
